import React from 'react';
import { makeStyles } from "@material-ui/core";
import { Collection } from "@type-r/models";
import { ListField } from "common/invoice-aging";
import { asCurrency, CollapsableSection, Flex, Link, TilesList } from "lqx-react/src";
import { SmallBox } from "src/app/pages/inmatch/invoices/invoicesList";
import { NewRelationshipGroup } from "../../api/customer-profile";

export const PendingNewRelationships = ({relationships}:{relationships : Collection<NewRelationshipGroup>}) => {
    return (<CustomerProfileOpenItems
                title={`Open Items - (${relationships.length})`}
                relationships={relationships}
                linkUrl='customerProfile' />
    );
}

export const CustomerProfileOpenItems = ({ title, relationships, linkUrl }:
    {
        title: String,
        relationships: Collection<NewRelationshipGroup>,
        linkUrl: String
    }) => {

    return (
        <CollapsableSection title={`${title}`}>
            <TilesList
                items={Array.from(relationships.filter(x=>x.hasCustomer))}
                itemSize={60}
                renderer={CustomerProfileOpenItem(linkUrl)}
                selectedItem={null}
                height={600} />
        </CollapsableSection>
    );
}

const CustomerProfileOpenItem = (linkUrl: String) => ({ data, style, index }) => {
    const item = data.items[index];
    const styles = openItemStyles();

    return (
        <div style={style}>
            <SmallBox>  
                <div className={styles.customerDetails} title={item.customerName}>
                    <Flex column>
                        <ListField className={styles.listField}>{item.customerName}</ListField>
                        <ListField className={styles.listField}>{item.customerExternalId}</ListField>
                    </Flex>
                </div>                           
                <ListField className={styles.listField}>{item.count} invoices</ListField>
                <ListField className={styles.amountSum}>Sum: {asCurrency(item.outstandingAmountSum)}</ListField>
                <ListField className={styles.listField}>
                    <Link href={linkUrl} params={{relationshipId: item.relationshipId}}>
                        View: Customer Profile
                    </Link>
                </ListField>                           
                <Flex grow></Flex>
            </SmallBox>
        </div>
    )
}

const openItemStyles = makeStyles({
    customerDetails: {
        width: 220,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    amountSum: {
        width: 200,
        color: "black"
    },
    listField: {
        color: "black"
    }
});
